/**
 * Detects Auth0 SPA errors where the user should be sent through logout / login again
 * (e.g. missing refresh token after reload, expired SSO session).
 */
export function isAuth0SessionRecoverableError(err: unknown): boolean {
  if (err == null || typeof err !== 'object') {
    return false;
  }

  const e = err as {
    error?: string;
    message?: string;
    error_description?: string;
  };

  const code = e.error?.toLowerCase();
  if (
    code === 'login_required' ||
    code === 'consent_required' ||
    code === 'interaction_required' ||
    code === 'missing_refresh_token'
  ) {
    return true;
  }

  const combined = [e.error, e.message, e.error_description]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  if (combined.includes('missing refresh token')) {
    return true;
  }
  if (combined.includes('login required') && !combined.includes('network')) {
    return true;
  }

  return false;
}
